"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linkStyles = void 0;

var _getColor = require("../styleHelpers/getColor");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var BASE_LINK_STYLES = {
  color: (0, _getColor.getColor)('brand', 'main'),
  textDecoration: 'none',
  fontStyle: 'normal',
  fontWeight: 'inherit'
};

var linkStyles = _objectSpread(_objectSpread({}, BASE_LINK_STYLES), {}, {
  hover: _objectSpread(_objectSpread({}, BASE_LINK_STYLES), {}, {
    textDecoration: 'underline'
  }),
  visited: _objectSpread({}, BASE_LINK_STYLES),
  focus: _objectSpread(_objectSpread({}, BASE_LINK_STYLES), {}, {
    textDecoration: 'underline'
  })
});

exports.linkStyles = linkStyles;